import data from "../../../../../src/Dialog.docs.json";
import * as React from 'react';
export default {
  data,
  React
};